import React from "react";
import { Layout, Typography } from "antd";
import "./styles.css";

export default function Footer(props) {
  const { Footer } = Layout;
  const { Title, Text, Link } = Typography;
  return (
    <Footer style={{ textAlign: "center" }} className="footer">
      {
        props?.footer?.map(item=>{
          return <Text>{item?.title}</Text>
        })
      }
    </Footer>
  );
}
